import { render, staticRenderFns } from "./editProductSeckill.vue?vue&type=template&id=116af080"
import script from "./editProductSeckill.vue?vue&type=script&lang=js"
export * from "./editProductSeckill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports